import { useAuthStore } from 'src/store/auth';

export const useForgotPassword = () => {
  const { forgotPassword, isLoading, error, success, clear } = useAuthStore();

  return {
    forgotPassword: async (data: { email: string }) => {
      await forgotPassword(data.email);
    },
    clear,
    isLoading,
    error,
    success,
  };
};
